<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>周平均数据</span>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      border
    >
      <el-table-column
        prop="week"
        label="周"
        width="200px"
        align="center"
      >
        <template v-slot:default="r">
          <span v-if="r.row.week !== '环比'">
            {{ r.row.week }} ( {{ r.row.start_date }} - {{ r.row.end_date }})
          </span>
          <span v-else>{{ r.row.week }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="consume"
        label="平均消耗"
        align="center"
      />
      <el-table-column
        prop="grant"
        label="平均发放"
        align="center"
      />
      <el-table-column
        prop="log_onlone"
        label="活跃在线时长"
        align="center"
      />
      <el-table-column
        prop="reg_online"
        label="注册在线时长"
        align="center"
      />
      <el-table-column
        prop="bet"
        label="人均bet"
        align="center"
      />
      <el-table-column
        prop="count"
        label="人均转动次数"
        align="center"
      />
      <el-table-column
        prop="login"
        label="人均登录"
        align="center"
      />
    </el-table>
  </el-card>
</template>

<script>
import { isNumeric } from 'echarts/lib/util/number'

export default {
  name: 'WeekAvg',
  data() {
    return {
      tableData: []
    }
  },
  created() {
  },
  methods: {
    init(data) {
      this.tableData = data
    },
    numFormatter(col, row, val) {
      if (col.week === '环比') {
        return val
      }
      return val + '%'
    },
    rate(start, end) {
      let rate = ((end - start) / start * 100).toFixed(2)
      if (!isNumeric(rate)) {
        rate = 0
      }
      if (rate > 0) {
        return <span style='color:#F56C6C'>{rate}%</span>
      } else {
        return <span style='color:#67C23A'>{rate}%</span>
      }
    }
  }
}
</script>

<style scoped>

</style>
